export default ({
  show,
  children,
}: {
  show: boolean;
  children: JSX.Element;
}): JSX.Element | null => {
  return show ? children : null;
};
